import instance from "../Service";

export default class Profile {
  static async upload_avatar(data) {
    return await instance.post("/profile/upload_avatar", data,
        {headers: {
            'Content-Type': 'multipart/form-data',
          },
        });
  }
  static async update_profile_data(data) {
    return instance.post("/profile/update_data", data);
  }
  static async delete_avatar() {
    return instance.post("/profile/delete_avatar");
  }
  static async update_password(data) {
    return await instance.post("/profile/update_password", data);
  }
  static async updateDeliveryInfo(data) {
    return await instance.put("/delivery/addresses", data);
  }
}
